<template>
  <v-dialog v-model="open" width="600px">
    <v-card>
      <v-toolbar elevation="0" color="background">
        <v-toolbar-title class="pl-3 text--subtitle">
          <v-icon color="primary" style="padding-bottom: 2px">
            {{ icon }}
          </v-icon>
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pl-7 pr-5 py-0">
        <v-container class="pl-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                autofocus
                outlined
                dense
                :rules="[
                  rulesToCreate.required,
                  rulesToCreate.maxLength,
                  rulesToCreate.minLength,
                ]"
                :label="$t('message.name')"
                required
                counter="255"
                color="primary"
                @keyup.enter="handleCreate"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-8 pb-6">
        <v-spacer></v-spacer>
        <v-btn text class="mr-4 px-4" @click="open = false">
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="px-10"
          :disabled="!canCreate || isCreating"
          :loading="isCreating"
          @click="handleCreate"
        >
          {{ $t('message.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/translations/lang'
export default {
  name: 'CreateModal',
  props: {
    openCreateModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    isCreating: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-test-tube',
    },
    initialValue: {
      type: String,
      required: false,
    },
    clearOnClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    name: '',
    rulesToCreate: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  mounted() {
    this.name = this.initialValue
  },
  watch: {
    initialValue(value) {
      this.name = value
    },
  },
  computed: {
    open: {
      get() {
        return this.openCreateModal
      },
      set(newValue) {
        if (!newValue) {
          if (this.clearOnClose) {
            this.name = ''
          }
          this.$emit('close')
        }
      },
    },
    canCreate() {
      const isValidCreateName = Object.keys(this.rulesToCreate).map((rule) => {
        if (this.rulesToCreate[rule](this.name) === true) return true
        return false
      })

      return isValidCreateName.every((test) => test === true)
    },
  },
  methods: {
    handleCreate() {
      this.$emit('create', this.name)
    },
  },
}
</script>
